import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Row, Col } from 'react-bootstrap';
var Services = function () {
    var services = [
        {
            icon: '💻',
            title: 'Software Development',
            description: 'Custom software development and assistance. Expert in C#, Java, Golang, TypeScript, and JavaScript. Building scalable, maintainable solutions tailored to your needs.'
        },
        {
            icon: '🗄️',
            title: 'Database & Infrastructure',
            description: 'Relational databases (SQL Server, MySQL), web servers, and robust infrastructure solutions. Expert implementation and optimization for your data needs.'
        },
        {
            icon: '☁️',
            title: 'AWS Cloud Services',
            description: 'Comprehensive AWS solutions including DynamoDB, Lambda, S3, EC2, and more. Cloud architecture design, migration, and optimization.'
        },
        {
            icon: '�',
            title: 'Kafka & Event Streaming',
            description: 'Custom Kafka implementations or Amazon MSK. Kafka Connect integration, Schema Registry setup, and real-time data streaming solutions.'
        },
        {
            icon: '�',
            title: 'Kubernetes & DevOps',
            description: 'Self-hosted Kubernetes or Amazon EKS deployments. Helm charts, CI/CD pipelines, and infrastructure automation for seamless deployments.'
        },
        {
            icon: '🏪',
            title: 'POS Sales Integration',
            description: 'Aloha Cloud & Clover POS integration. Out-of-the-box sales reporting and dashboards. View all sales across stores, build custom reports, and extract data for internal systems.'
        }
    ];
    return (_jsx("section", { id: "services", className: "services-section", children: _jsxs(Container, { children: [_jsxs("div", { className: "text-center mb-5", children: [_jsx("h2", { className: "section-title", children: "Our Services" }), _jsx("p", { className: "section-subtitle", children: "Comprehensive software consulting services to accelerate your digital transformation" })] }), _jsx(Row, { children: services.map(function (service, index) { return (_jsx(Col, { lg: 4, md: 6, className: "mb-4", children: _jsxs("div", { className: "service-card", children: [_jsx("div", { className: "service-icon", children: service.icon }), _jsx("h3", { children: service.title }), _jsx("p", { children: service.description })] }) }, index)); }) })] }) }));
};
export default Services;
